module.exports = __webpack_public_path__ + "media/images/icon-arrow-down-carnation-e6201b251673aaba1e9ef5d5731a040a.svg";